import type { GetWalletIFrameParamers, OpenWalletParamers, WalletPlugin } from '@particle-network/wallet-plugin';
import { useMemo } from 'react';
import { useContext } from '../context';

export type UseEmbeddedWalletReturnType = {
  openWallet: (parameters?: OpenWalletParamers) => void;
  destory: () => void;
  getWalletIFrame: (parameters?: GetWalletIFrameParamers) => void;
  isCanOpen: boolean;
};

export const useEmbeddedWallet = (): UseEmbeddedWalletReturnType | null => {
  const { config } = useContext();
  const walletPlugin = useMemo(() => {
    const plugin = config.plugins.find((plugin) => plugin.id === 'wallet');
    if (plugin) {
      return plugin as WalletPlugin;
    }
    return undefined;
  }, []);

  const isCanOpen = useMemo(() => {
    return walletPlugin?.getPlugin().walletOptions.widgetIntegration !== 'embedded';
  }, [walletPlugin]);

  if (!walletPlugin) {
    return null;
  }

  return {
    openWallet: walletPlugin.openWallet.bind(walletPlugin),
    destory: walletPlugin.destory.bind(walletPlugin),
    getWalletIFrame: walletPlugin.getWalletIFrame.bind(walletPlugin),
    isCanOpen,
  };
};
